import {
  buildProductAnalyticsBpContext,
  buildThirdPartyIntegrationBpContext,
  buildWebBpContext,
  buildTeamBpContext,
  buildViewBpContext,
  ProductAnalyticsBpContext,
  ThirdPartyIntegrationBpContext,
  WebBpContext,
  TeamBpContext,
  ViewBpContext,
} from '@vimeo/use-tracking';

export interface ContextOverrides {
  product_analytics_context?: Partial<ProductAnalyticsBpContext>;
  third_party_integration_context?: Partial<ThirdPartyIntegrationBpContext>;
  web_context?: Partial<WebBpContext>;
  team_context?: Partial<TeamBpContext>;
  view_context?: Partial<ViewBpContext>;
}

class BigPictureContextBuilder {
  private contexts: Record<string, unknown> = {};

  public static CONTEXT_CONFIGURATION_MAP = {
    ...buildProductAnalyticsBpContext({
      product: 'general',
      feature: 'general',
      location: 'not_applicable_pageview',
    }),
    ...buildThirdPartyIntegrationBpContext({
      is_integration: false,
      integration_id: null,
      integration_name: null,
      is_partner: null,
    }),
    ...buildWebBpContext({
      page_name: 'other',
    }),
    ...buildTeamBpContext({
      is_team_member: false,
    }),
    ...buildViewBpContext({
      view_type: 'impression',
      feature: null,
    }),
  };

  constructor(overrides: ContextOverrides = {}) {
    this.initializeContexts(overrides);
  }

  private initializeContexts(overrides: ContextOverrides): void {
    for (const [key, defaultContext] of Object.entries(
      BigPictureContextBuilder.CONTEXT_CONFIGURATION_MAP,
    )) {
      const contextOverrides = overrides[key as keyof ContextOverrides] || {};
      const defaultFields = defaultContext.fields || {};

      this.contexts[key] = {
        ...defaultContext,
        fields: { ...defaultFields, ...contextOverrides },
      };
    }
  }

  public getAllContexts(): Record<string, unknown> {
    return this.contexts;
  }
}

export default BigPictureContextBuilder;
